import { connect } from "react-redux"
import React, { Fragment, Component } from "react"

import type { Stakeholder } from "../../../../types/types"
import ImageSelector from "../../../common/ImageSelector"

type AdditionalProps = {
    onEventChange: void => void,
    onImageChange: void => void
}

class StakeholderEditItemDetails extends Component<
    Stakeholder & AdditionalProps
> {
    render() {
        const {
            full_name,
            primary_organisation,
            primary_position,
            bio,
            photo_url,
            type,
            imagePreviewURL,
            isCreateMode,
            onEventChange,
            onImageChange
        } = this.props

        return (
            <div className="widget">
                <div className="widget-content">
                    <h3 className="first-heading">
                        <i className="icon icon-headline" />Stakeholder Type
                    </h3>
                    <select
                        name="type"
                        className="form-control"
                        value={type}
                        onChange={onEventChange}
                        disabled={!isCreateMode}
                        data-cy="stakeholderTypeSelect"
                    >
                        <option value="Organisation">Organisation</option>
                        <option value="Person">Person</option>
                    </select>
                    <h3>
                        <i className="icon icon-headline" />Full Name
                    </h3>
                    <input
                        type="text"
                        name="full_name"
                        className="form-control"
                        placeholder="Full Name"
                        value={full_name || ""}
                        onChange={onEventChange}
                        data-cy="stakeholderFullNameInput"
                    />
                    {type === "Person" && (
                        <Fragment>
                            <h3>
                                <i className="icon icon-user-primary-org" />Primary
                                Organisation
                            </h3>
                            <input
                                name="primary_organisation"
                                className="form-control"
                                placeholder="Primary Organisation"
                                value={primary_organisation || ""}
                                onChange={onEventChange}
                                data-cy="stakeholderPrimaryOrganisationInput"
                            />

                            <h3>
                                <i className="icon icon-user-primary-position" />Primary
                                Position
                            </h3>
                            <input
                                name="primary_position"
                                className="form-control"
                                placeholder="Primary Position"
                                value={primary_position || ""}
                                onChange={onEventChange}
                                data-cy="stakeholderPrimaryPositionInput"
                            />
                        </Fragment>
                    )}
                    <h3>
                        <i className="icon icon-description" />Bio
                    </h3>
                    <textarea
                        rows="4"
                        columns="50"
                        name="bio"
                        className="form-control"
                        placeholder="Bio"
                        onChange={onEventChange}
                        data-cy="stakeholderBioInput"
                    >
                        {bio}
                    </textarea>
                    <h3>
                        <i className="icon icon-heroimg" />User Picture
                    </h3>
                    <ImageSelector
                        onImageSelect={onImageChange}
                        imageUrl={
                            imagePreviewURL !== undefined ? (
                                imagePreviewURL
                            ) : (
                                photo_url
                            )
                        }
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ presentation: { stakeholders } }) => ({
    isCreateMode: stakeholders.isCreateMode
})

export default connect(mapStateToProps)(StakeholderEditItemDetails)
